function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9177",
  "data-name": "Group 9177",
  transform: "translate(-347 -189)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M17,0a17.728,17.728,0,0,1,3.91.452A17.015,17.015,0,1,1,17,0Z",
  transform: "translate(347 189)",
  fill: "#fff",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M3.065,12.3a.611.611,0,0,0,.055.092l9.23,10.153c0,.009.018.009.023.018a.573.573,0,0,0,.106.078c.014.009.028.014.042.023a.7.7,0,0,0,.171.028.4.4,0,0,0,.166-.037.187.187,0,0,0,.042-.023.353.353,0,0,0,.106-.078c.009-.009.018-.009.023-.018l9.23-10.153a.377.377,0,0,0,.055-.092.154.154,0,0,0,.028-.046.426.426,0,0,0,.032-.166v0a.135.135,0,0,0-.009-.042.5.5,0,0,0-.023-.12.461.461,0,0,0-.037-.065c-.014-.018-.018-.042-.032-.065L18.58,7.166s-.014-.009-.018-.014a.426.426,0,0,0-.1-.078.385.385,0,0,0-.055-.037s-.009-.009-.014-.009A.341.341,0,0,0,18.257,7s-.014,0-.028,0H7.154c-.014,0-.028.009-.042.009a.424.424,0,0,0-.129.023s-.009.009-.014.009a.232.232,0,0,0-.055.037.426.426,0,0,0-.1.078s-.014.009-.018.014L3.1,11.786a.282.282,0,0,0-.032.065.461.461,0,0,0-.037.065.368.368,0,0,0-.023.12A.135.135,0,0,0,3,12.077v0A.816.816,0,0,0,3.065,12.3Zm1.44.24H8.676l2.783,7.647Zm8.187,8.339L9.659,12.538h6.064Zm1.232-.692,2.783-7.647h4.172Zm4.44-11.819,2.6,3.249h-3.9Zm-.817-.443-1.3,3.249-2.6-3.249Zm-2.123,3.692H9.959l1.147-1.434L12.692,8.2ZM11.732,7.923l-2.6,3.249-1.3-3.249ZM7.02,8.366l1.3,3.249h-3.9Z",
  transform: "translate(351.137 192)",
  fill: "#687c97",
  stroke: "#687c97",
  strokeMiterlimit: 10,
  strokeWidth: 0.2
}));

function SvgDiamondGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondGray);
export default __webpack_public_path__ + "static/media/diamond-gray.bd3d1bf1.svg";
export { ForwardRef as ReactComponent };